import { React, classNames, withStyles, StyledProps, observable, Fragment } from '@api'
import {LinkOff} from '@material-ui/icons'
import * as _ from 'lodash'
import { CardMedia } from '@material-ui/core'
import {CardSizeType } from 'centric-ui-components'
import { observer } from 'mobx-react';
import * as css from './LazyLoadMedia.css'

const styles = () => ({
  placeholder:     {
    height:          250,
    // width:           234,
    backgroundColor: '#fff'
  },
  mediaSelected:   {
    backgroundColor: 'transparent !important'
  },
  inactive:        {
    pointerEvents: 'none',
    cursor:        'not-allowed'
  },
  inactiveWrapper: {
    position: 'relative'
  },
  xlarge_inactiveIcon:    {
    height: 300,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '50%',
    top: '-10%',
    borderLeft: '2px solid red',
    zIndex: 1
  },
  large_inactiveIcon:    {
    height: 300,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '50%',
    top: '-10%',
    borderLeft: '2px solid red',
    zIndex: 1
  },
  medium_inactiveIcon: {
    height: 180,
    width: 180,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '33%',
    top: '32%',
    borderLeft: '2px solid red',
    zIndex: 999
  }
})

interface MyProps extends StyledProps {
  image?: string | React.ReactNode
  height?: number
  width?: number
  isActive?: boolean
  isSelected?: boolean
  id?: string | number,
  onDragEnter?: (e, id) => void
  onDragLeave?: (e, id) => void
  onDragOver?: (e, id) => void
  onDrop?: (e) => void
  showIcon?: boolean,
  cardSize: CardSizeType | string,
  showHex?: boolean,
  hex?: string,
  draggable?: boolean,
  cardSizes: {[size: string]: number}
  onLoad?: (e) => void
}

@observer
export class LazyLoadMediaComponent extends React.Component<MyProps> {
  static defaultProps = {
    cardSize: 'xlarge',
    draggable: true,
    // cardSizes: {'mini': 24, 'small': 40, 'medium': 180, 'large': 250, 'xlarge': 250}
    cardSizes: { 
      width: {'mini': 24, 'small': 40, 'medium': 180, 'large': 250}, 
      height: {'mini': 24, 'small': 40, 'medium': 180, 'large': 250, 'xlarge': 250}
    }
  }

  @observable imageError = false

  render() {
    const {
      props: {
        className, id, image, classes, children, height, width, isActive,
        showHex, hex, isSelected, onDragEnter, onDragLeave, onDragOver, showIcon,
        cardSize, draggable, cardSizes, ...other
      },
      onImageError, imageError
    } = this;

    let draggableAttribute = {
      draggable
    }

    const commonProps = {
      'data-size': cardSize,
      'data-type': 'LazyLoadMedia',
      onDragEnter: onDragEnter ? (e) => onDragEnter(e, id) : undefined,
      onDragOver: e => onDragOver ? onDragOver(e, id) : (onDragEnter ? onDragEnter(e, id) : null),
      onDragLeave: onDragLeave ? e => onDragLeave(e, id) : undefined
    }
    return (
      <Fragment>
        {hex ? <div
               {...commonProps}
               className={classNames(className, css.root)}
               style={{
                 backgroundColor: `${hex}`,
               }}
               draggable={false}
             />
             : !_.isString(image) || imageError?
               <div
                 {...commonProps}
                 className={classNames(className, css.root)}
                 style={{
                   backgroundColor: `${hex}`,
                 }}
                 draggable={false}
               >
                 {imageError ? <span className={css.no_image}>
          <LinkOff/>
       </span> : image}
               </div>
                                  : <CardMedia
                 className={classNames(className, css.media, css.root,
                   {[classes.mediaSelected]: isSelected},
                   {[`${classes.inactive} inactive`]: !isActive}
                 )}
                 {...commonProps}
                 src={hex ? '' : _.isString(image) ? image : ''}
                 component={_.isString(image) ? 'img' : 'div'}
                 {...draggableAttribute}
                 {...other}
                //  {...{crossOrigin: 'Anonymous'} as any}
                 style={{
                   backgroundColor: showHex ? hex : 'white'
                 }}
               >{!_.isString(image) ? image : children}</CardMedia>}
      </Fragment>
    )
  }

  onImageError = e => {
    this.imageError = true
  }
}

@(withStyles as any)(styles)
export class LazyLoadMedia extends LazyLoadMediaComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/LazyLoadMedia.tsx